module.exports = __webpack_public_path__ + "img/Sentiment.92b5f471.svg";